import { NavigationOptionsType, WidgetNames } from '../config.type';
import { NavigationOptionEnum } from '../workflow.type';

export enum ListActionValue {
  VIEW_DETAIL = 'view-detail',
  DOWNLOAD_RECEIPT = 'download-receipt',
  RENAME = 'rename',
  DELETE = 'delete',
  FAVOURITE = 'favourite',
  EDIT = 'edit',
  DOWNLOAD = 'download',
  MARK_AS_READ = 'mark-as-read',
  CANCEL = 'cancel',
}

export type ListingAction = {
  enableActionColumn: boolean;
  actions: ListActionValue[];
  rowGap?: number;
  columnHeader: string;
  actionsConfig?: ActionConfig[];
};

export type ActionConfig = {
  action: ListActionValue;
  isActionSelected: boolean;
  class: string;
  linkToGlobalStyling: boolean;
  actionTitle: string;
  navigationOptionConfig: NavigationOptionsType;
  position?: 'left' | 'right';
};

const accountListingOptions = [
  { label: 'View', value: ListActionValue.VIEW_DETAIL },
  { label: 'Rename', value: ListActionValue.RENAME },
];

const notificationListOptions = [
  { label: 'Download', value: ListActionValue.DOWNLOAD },
  { label: 'Mark As Read', value: ListActionValue.MARK_AS_READ },
  { label: 'Delete', value: ListActionValue.DELETE },
];

export const getListActionOptions = (
  widgetName: string | WidgetNames,
): { label: string; value: string }[] => {
  const optionsMap: {
    [key: string]: { label: string; value: string }[];
  } = {
    [WidgetNames.RECENT_TRANSACTION_LIST_WIDGET]: [
      { label: 'View', value: ListActionValue.VIEW_DETAIL },
      { label: 'Download Statement', value: ListActionValue.DOWNLOAD_RECEIPT },
    ],
    [WidgetNames.CURRENCY_ACCOUNTS_LISTING_WIDGET]: accountListingOptions,
    [WidgetNames.LANDING_ACCOUNTS_LISTING]: accountListingOptions,
    [WidgetNames.NOTIFICATION_LIST_WIDGET]: notificationListOptions,
    [WidgetNames.BENEFICIARY_SELECTION_WIDGET]: [
      { label: 'Edit', value: ListActionValue.EDIT },
      { label: 'Delete', value: ListActionValue.DELETE },
      { label: 'Favourite', value: ListActionValue.FAVOURITE },
      { label: 'View', value: ListActionValue.VIEW_DETAIL },
    ],
    [WidgetNames.VARIABLE_RECURRING_PAYMENT_LIST_WIDGET]: [
      { label: 'Cancel', value: ListActionValue.CANCEL },
    ],
    // Add more widget-specific options here
  };

  return optionsMap[widgetName] ?? [];
};

export const listActionSupportedWidgets: readonly (WidgetNames | string)[] = [
  WidgetNames.RECENT_TRANSACTION_LIST_WIDGET,
  WidgetNames.LANDING_ACCOUNTS_LISTING,
  WidgetNames.CURRENCY_ACCOUNTS_LISTING_WIDGET,
  WidgetNames.BENEFICIARY_SELECTION_WIDGET,
  WidgetNames.NOTIFICATION_LIST_WIDGET,
  WidgetNames.VARIABLE_RECURRING_PAYMENT_LIST_WIDGET,
  // Add more supported widgets here
];

export function handleExternalNavigation(config: NavigationOptionsType): void {
  if (config?.navigationOption === NavigationOptionEnum.USE_AS_BLANK || !config?.externalUrl) {
    return;
  }

  switch (config.browserBehaviour) {
    case 'new-tab':
      window.open(config.externalUrl, '_blank');
      break;

    case 'new-window':
      window.open(config.externalUrl, '_blank', 'width=800,height=600');
      break;

    default:
      window.open(config.externalUrl, '_self');
      break;
  }
}
